import { styled } from "@mui/material/styles";
import Scrollbar from "react-perfect-scrollbar";
import { useTheme } from "@mui/material/styles";
import { MatxVerticalNav } from "app/components";
import { navigations } from "app/navigations";
import React, { Fragment } from "react";
import { Box, TextField, InputAdornment, Icon } from "@mui/material";

// STYLED COMPONENTS
const StyledScrollBar = styled(Scrollbar)(() => ({
  paddingLeft: "1rem",
  paddingRight: "1rem",
  position: "relative",
}));

// Container for the search bar to give it spacing
const SearchContainer = styled(Box)(({ theme }) => ({
  padding: "12px 16px",
  position: "sticky",
  top: 0,
  zIndex: 99,
}));

export default function Sidenav({ children }) {
  const [searchTerm, setSearchTerm] = React.useState("");
  const theme = useTheme();

  // Recursive filter for nested navigation items
  const filterNavigations = (items, term) => {
    if (!term) return items;

    return items.reduce((acc, item) => {
      const matches =
        item.name?.toLowerCase().includes(term.toLowerCase()) ||
        item.label?.toLowerCase().includes(term.toLowerCase());

      if (item.children) {
        const filteredChildren = filterNavigations(item.children, term);
        if (filteredChildren.length > 0 || matches) {
          acc.push({
            ...item,
            children: matches ? item.children : filteredChildren,
          });
        }
      } else if (matches) {
        acc.push(item);
      }
      return acc;
    }, []);
  };

  // Memoize the filtered result for performance
  const filteredItems = React.useMemo(
    () => filterNavigations(navigations, searchTerm),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchTerm]
  );

  return (
    <Fragment>
      <StyledScrollBar options={{ suppressScrollX: true }}>
        {children}
        <SearchContainer>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            placeholder="Search menu..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Icon sx={{ fontSize: "1.2rem", color: theme.palette.text.secondary }}>
                    search
                  </Icon>
                </InputAdornment>
              ),
              sx: {
                borderRadius: "20px",
                backgroundColor: theme.palette.background.paper,
                fontSize: "0.875rem",
              },
            }}
          />
        </SearchContainer>
        <MatxVerticalNav items={filteredItems} />
      </StyledScrollBar>
    </Fragment>
  );
}
